export default __webpack_public_path__ + "static/media/USDT.86a30017.png";